import { useCompanyTheme } from '@ui/hooks/useCompanyTheme';
import { DEFAULT_EMAIL_PLACEHOLDER_VALUES } from '@ui/pages/Events/EventsHomePage/EventDetails/PreferencesTab/emailConfiguration/templates/english/invitationEmailDefaultEng';
export const mapPrimaryColorToIconFolder = (primaryColor) => {
    const hex = (primaryColor || '').trim().toUpperCase();
    switch (hex) {
        case '#00B6ED':
            return 'Sky_Blue_Icons';
        case '#3192D0':
            return 'Ocean_Blue_Icons';
        case '#2D3077':
            return 'Dark_Blue_Icons';
        case '#00244D':
            return 'Midnight_Blue_Icons';
        case '#E52322':
            return 'Red_Icons';
        case '#76B82A':
            return 'Green_Icons';
        case '#FFDD00':
            return 'Yellow_Icons';
        case '#E94E1B':
        default:
            return 'Orange_Icons';
    }
};
export const getContrastColorForPrimary = (primaryColor) => {
    const hex = (primaryColor || '').trim().toUpperCase();
    switch (hex) {
        case '#00B6ED':
        case '#FFDD00':
        case '#76B82A':
            return '#000000';
        case '#3192D0':
        case '#2D3077':
        case '#00244D':
        case '#E52322':
        case '#E94E1B':
        default:
            return '#FFFFFF';
    }
};
export const useEmailPrimaryColor = () => {
    const { theme } = useCompanyTheme();
    if (theme?.primaryColor) {
        return theme.primaryColor;
    }
    return DEFAULT_EMAIL_PLACEHOLDER_VALUES.Primary_Color;
};
export const useEmailContrastColor = () => {
    const primaryColor = useEmailPrimaryColor();
    return getContrastColorForPrimary(primaryColor);
};
